export default __webpack_public_path__ + "static/media/Baccarat-Mobile-Landscape.7a5710bf.webp";